import { Image } from "@/components/ui/image";

// Avatar de usuario: muestra la foto de perfil (photo_url) si existe,
// de lo contrario la inicial del nombre/correo. Se usa en el menú de la
// plataforma, el menú del landing y la página de perfil.
export default function Avatar({ user, size = 28, className = "" }) {
  const photo = user?.photo_url;
  const initial = (user?.full_name || user?.email || "U").slice(0, 1).toUpperCase();

  if (photo) {
    return (
      <div
        className={`shrink-0 overflow-hidden bg-ink-border ${className}`}
        style={{ width: size, height: size }}
      >
        <Image
          src={photo}
          alt={user?.full_name || "avatar"}
          fittingType="fill"
          className="w-full h-full"
        />
      </div>
    );
  }

  return (
    <div
      className={`shrink-0 bg-ink-border flex items-center justify-center font-display font-bold text-ink-text ${className}`}
      style={{ width: size, height: size, fontSize: Math.max(10, size * 0.4) }}
    >
      {initial}
    </div>
  );
}